const CwBlockUI = (props: {
    blocking: boolean | undefined
    className: string
}): React.JSX.Element | null => {
    return props.blocking ? (
        <div
            className={props.className}
            style={{
                backgroundColor: "white",
                position: "absolute",
                zIndex: 10,
                opacity: 0.7,
            }}
        >
            <div className="loader" />
        </div>
    ) : null
}
export default CwBlockUI
